import TicketCreate from '@/views/ticket/Create.vue'
import TicketList from '@/views/ticket/List.vue'
import TicketSingle from '@/views/ticket/Single.vue'

export default [
  {
    path: '/tc',
    name: 'ticket-create',
    component: TicketCreate,
    meta: {
      auth: 'all',
      breadcrumbs: [
        {
          link: 'ticket-create',
          title: 'Support Ticket'
        }
      ]
    }
  },
  {
    path: '/tl',
    name: 'ticket-list',
    component: TicketList,
    meta: {
      auth: ['admin'],
      breadcrumbs: [
        {
          link: 'ticket-list',
          title: 'Tickets'
        }
      ]
    }
  },
  {
    path: '/ts/:id',
    name: 'ticket-single',
    component: TicketSingle,
    meta: {
      auth: ['admin'],
      breadcrumbs: [
        {
          link: 'ticket-list',
          title: 'Tickets'
        },
        {
          link: 'ticket-single',
          title: 'Ticket Single',
          params: 'id'
        }
      ]
    }
  }
]
